import { render } from "./SeparatorPage.vue?vue&type=template&id=ef96831e&scoped=true"
import script from "./SeparatorPage.vue?vue&type=script&lang=js"
export * from "./SeparatorPage.vue?vue&type=script&lang=js"

import "./SeparatorPage.vue?vue&type=style&index=0&id=ef96831e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef96831e"],['__file',"src/components/h5/layout/SeparatorPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ef96831e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ef96831e', __exports__)) {
    api.reload('ef96831e', __exports__)
  }
  
  module.hot.accept("./SeparatorPage.vue?vue&type=template&id=ef96831e&scoped=true", () => {
    api.rerender('ef96831e', render)
  })

}


export default __exports__